export class OwlCarouselSettings {
  public static Margin = 16;
  public static Autoplay = true;
  public static AutoplayTimeout = 7000;
  public static AutoplaySpeed = 700;
}
